import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadInvoice = (context, folderId) => new Promise((resolve, reject) => {
  Api.folderService.getInspectionInvoice(folderId)
    .then(response => {
      context.commit('setInvoice', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setInvoice', {});
      Http.setGlobalError(context, Http.createError(error, 'invoice.actions.loadInvoice', { folderId }));
      reject();
    });
});

export default {
  loadInvoice,
};
